<!--左部菜单切换栏-->
<template>
  <div id="left_bar">
    <div class="left_logo">
      <img src="@/assets/thdImg/logo/logo.svg" alt="" srcset="" />
    </div>
    <el-menu
      class="el-menu-vertical-demo left_menu"
      @open="handleOpen"
      :default-active="activeNow"
      unique-opened
      router
      text-color="#fff"
      active-text-color="#fff"
      @close="handleClose"
    >
      <div v-for="(item, ind) in navInfo" :key="ind">
        <el-submenu :index="item.path" v-if="item.children && item.children.length !== 0" class="left-nav-color">
          <template slot="title">
            <!-- <img v-if="item.icon" :src="$store.state.leftNavActive == ind ? item.icon_active : item.icon" style="margin-right: 6px; width: 16px;heihgt:16px;"> -->
            <img :src="item.icon" style="margin-right: 10px;width: 16px;" />
            <span style="display:inline-block">{{ item.tittle }}</span>
          </template>

          <el-menu-item
            :index="child.path"
            @click.native.stop.prevent="routerpush(item.path, child.path)"
            v-for="(child, index) in item.children"
            :key="index"
            >{{ child.tittle }}
            <img v-if="child.tittle == '商品复购'" src="@/assets/images/tag_hot.png" style="margin-left: 1px;" />
            <img v-if="child.tittle == '白条免息活动'" src="@/assets/images/new.png" style="margin-left: 1px;margin-top: -4px;" />
          </el-menu-item>
        </el-submenu>
        <!-- ='item.children.length===0' -->
        <!-- <el-menu-item :index="item.path" @click="currentNavIndex = ind" v-else> -->
        <el-menu-item
          :index="item.path"
          @click.native.stop.prevent="routerpush1(item.path, ind)"
          v-else
          style="left:-7px;height:44px;line-height:44px;"
        >
          <span slot="title">
            <img v-if="item.icon" :src="item.icon" style="margin-bottom: 2px;width: 16px;margin-right: 5px;" />
            {{ item.tittle }}
          </span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "left-select",
  props: {
    paths: {
      type: Array,
      require: true,
    },
  },
  watch: {
    paths(newVal, oldVal) {
      // this.paths.length > 0 && (this.activeNow = this.paths[this.paths.length - 1].path);
      if (this.$route.meta.activeMange) {
        this.activeNow = this.$route.meta.activeMange;
      } else {
        this.activeNow = this.$route.name == "newhome" ? "home" : this.$route.name;
      }
    },
  },
  data() {
    return {
      navInfo: [], //从顶部栏获取到的子菜单
      activeNow: "", //当前激活的菜单
      updatebar: true,
      menu1: "", //一级菜单路由
      oldpath: "",
    };
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    routerpush(path, path1) {
      console.log("点击侧边栏==2222", path);
      for (let i = 0; i < this.navInfo.length; i++) {
        if (this.navInfo[i].path === path) {
          sessionStorage.setItem("leftNavActive", i);
        }
      }
      // 重定向二级路由跳转
      // console.log(this.menu1,path,path1);
      this.oldpath = "";
      // console.log('path:', this.menu1+'/'+path+'/'+path1)
      this.$router.push({ path: this.menu1 + "/" + path + "/" + path1 });
    },
    routerpush1(path, ind, i) {
      console.log("点击侧边栏==");
      // 重定向一级路由跳转
      // console.log(this.menu1,path,path1);
      if (this.oldpath == path) {
        this.$router.push({ path: this.menu1 + "/" + path });
        // location.reload()
      } else {
        sessionStorage.setItem("leftNavActive", ind);
        // console.log(this.menu1,path,ind);
        // return
        this.$router.push({ path: this.menu1 + "/" + path });
        // window.location.reload()
        // this.$forceUpdate();
        this.oldpath = path;
      }
    },
  },
  mounted() {
    this.bus.$on("topActive", (obj) => {
      this.navInfo = obj.item.children;
      this.menu1 = obj.item.path;
      this.updatebar = false;
      let that = this;
      this.$nextTick(() => {
        that.updatebar = true;
      });
      // console.log("mounted侧边栏==", obj);
    });
  },
};
</script>
<style lang="scss" scoped>
#left_bar {
  width: 200px;
  padding-top: 10px;
  // position: fixed; /*设置元素为固定定位*/
  // z-index: 5;
  .left_logo {
    width: 98px;
    margin: 30px auto;
    // margin-top: 30px;
    img {
      width: 98px;
    }
  }
  // .el-menu {
  //   background-color: #000c4c !important;
  // }
  // /deep/.el-menu--inline {
  //   background-color: #121432 !important;
  // }
  .el-menu .is-opened .left-nav-color {
    font-weight: 500;
    color: #ffffff !important;
    background-color: #121432 !important;
  }
  /deep/.left-nav-color .el-submenu__icon-arrow {
    right: 10px;
  }
}
</style>
